<!-- <div class="chat-header-container">
  <header class="chat-header-3d">
    <div class="header-inner">
      <i class="fas fa-graduation-cap header-icon"></i>
      <div class="header-text">
        <h3 class="header-title">Centre for Distance and Online Education</h3>
        <p class="header-subtitle">Ask any academic question and get instant answers</p>
      </div>
    </div>
    <div class="header-shadow"></div>
  </header>
</div> -->
<div class="chat-app">
  <div class="chat-header">
    <h2 class="text-white"><i class="fas fa-graduation-cap"></i> {{showHindi ? 'चैट सहायक (दूरस्थ एवं ऑनलाइन शिक्षा केंद्र)' : 'Chat Assistant (CDOE)'}}</h2>
    <button class="lang-toggle" (click)="toggleLanguage()">
      {{showHindi ? 'English' : 'हिंदी'}}
    </button>
  </div>

  <div #chatBox class="message-container">
    <div *ngFor="let msg of messages" class="message" [class.outgoing]="msg.isUser" [class.incoming]="!msg.isUser">
      <div class="message-bubble" [innerHTML]="msg.content"></div>
      <div *ngIf="msg.isTyping" class="typing-indicator">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
  </div>

  <div class="suggestions-container" *ngIf="relatedQuestions.length > 0">
    <!--<div class="suggestions-title" styel="display:none;">
      {{showHindi ? 'संबंधित प्रश्न' : 'Related Questions'}}
    </div>-->
    <div class="suggestions-list">
      <div *ngFor="let question of relatedQuestions" 
           class="suggestion-item"
           (click)="selectQuestion(question)"
        [innerHTML]="showHindi ? question.questionHindi : question.question">
      </div>
    </div>
  </div>

  <div class="input-area">
    <input #userInput 
           type="text" 
           class="message-input"
           [(ngModel)]="currentInput"
           (input)="onInputChange($event)"
           (keyup.enter)="sendMessage()"
           (focus)="onInputFocus()"
           (blur)="onInputBlur()"
           placeholder="{{showHindi ? 'अपना प्रश्न टाइप 📋 करें या 🎤 बोले...' : '🎤 Voice or 📋 Type your question...'}}">
    <button class="send-button" (click)="sendMessage()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </div>
</div>

<div class="faq-container">
  <h2><i class="fas fa-question-circle"></i> {{showHindi ? 'सुभारती चैट सहायक का उपयोग' : 'How to Use Subharti Chat Assistant'}}</h2>
  
  <div class="faq-item" *ngFor="let item of faqItems; let i = index">
    <div class="faq-question" (click)="toggleFaq(i)" >
      <span [innerHTML]="showHindi ? item.questionHindi : item.question"></span>
      <i class="fas" [class.fa-chevron-down]="!item.isExpanded" [class.fa-chevron-up]="item.isExpanded"></i>
    </div>
     
    <div class="faq-answer" *ngIf="item.isExpanded" [@fadeIn]
     [innerHTML]="showHindi ? item.answerHindi : item.answer">
</div>
  </div>
</div>

